const riot = require('riot');
import '../components/properties.tag'
riot.tag2('page-properties', '<properties></properties>', '', '', function(opts) {
});
